module.exports = __webpack_public_path__ + "img/arrow-list-icon.53b55aa5.svg";